// extracted by mini-css-extract-plugin
module.exports = {"text":"propertyDetails_text__3qKRk"};
    if(module.hot) {
      // 1790670313388
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  